module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metasasha/metabase/sso-release/v0.45.4.2/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metasasha/metabase/sso-release/v0.45.4.2/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}